export namespace seo {
  export namespace og {
    export namespace image {
      export const logo = "/og/logo.png";
      export const index = "/og/default.png";
    }
  }

  export namespace get {
    export namespace global {
      export const keywords = ["incigma", "apps", "free", "online", "tools", "internet tasks", "free online tools"];
    }
  }
  export namespace set {
    export namespace index {
      export function fn() {
        const data = {
          title: "Incigma - Apps",
          description: "Free online tools for internet tasks.",
          keywords: [...seo.get.global.keywords],
          author: "Incigma.com",
          image: seo.og.image.index
        };

        useNuxtApp().$seo.simple(data);
      }
    }
  }
}

export namespace nuxt {
  export namespace context {
    export type schema = ReturnType<typeof useNuxtApp>;
  }
}
